import axios from 'axios';

// Configure axios to send cookies with all requests by default
axios.defaults.withCredentials = true;

export default axios;
